import { createApiSlice } from "@common";
import {
     MY_INFO_CONTACT
} from "@routes";

// Define the API config array
const apiConfig = [
    {
        name: "addMyInfoContactDetails",
        method: "post",
        url:  MY_INFO_CONTACT,
        stateKey: "message",
    },
    {
        name: "getMyInfoContactDetails",
        method: "get",
        url:  MY_INFO_CONTACT,
        stateKey: "data",
    },
    {
        name: "updateMyInfoContactDetails",
        method: "put",
        url:  MY_INFO_CONTACT,
        stateKey: "message",
    },
    {
        name: "deleteMyInfoContactDetails",
        method: "delete",
        url:  MY_INFO_CONTACT,
        stateKey: "message",
    },
];

// Define custom reducers and their initial state
const customReducers = {
    initialState: {
        data: [],
        additionalData: [],
    },
    reducers: {
        setAdditionalData: (state, action) => {
            state.additionalData = action.payload;
        },
    },
    extraReducers: {
        // Example of custom extra reducer
        someCustomAction: (state, action) => {
            // Custom reducer logic
        },
    },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
    "MyInfoContactDetails",
    apiConfig,
    customReducers,
);
const MyInfoContactDetailsSlice = slice;
// Export the slice's reducer
export default MyInfoContactDetailsSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
    addMyInfoContactDetails,
    getMyInfoContactDetails,
    updateMyInfoContactDetails,
    deleteMyInfoContactDetails
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
    actions;
